import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { handleClick, handleMouseEnter } from './utils';
import './styles.scss';

function HtmlComponent({ code, csscode, jscode }) {
  const history = useHistory();
  const [currentScroll, setScroll] = React.useState(0);
  const cssCode = `
    <style>
      ${csscode}
    </style>
  `;

  React.useEffect(() => {
    // added this code React does NOT run scripts on dangerouslySetInnerHTML
    if (jscode) {
      const script = document.createElement('script');
      script.innerHTML = jscode;
      document.body.appendChild(script);

      // cleaning if the component is unmounted
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [jscode]);

  return (
    <section
      className="html-component"
      dangerouslySetInnerHTML={{
        __html: `
        ${csscode ? cssCode : ''}
        ${code}
      `,
      }}
      onMouseEnter={() =>
        handleMouseEnter({
          currentScroll,
          setScroll,
        })
      }
      onClick={(event) =>
        handleClick({
          event,
          history,
          currentScroll,
          setScroll,
        })
      }
    />
  );
}

HtmlComponent.propTypes = {
  code: PropTypes.string.isRequired,
  csscode: PropTypes.string,
  jscode: PropTypes.string,
};

export default memo(HtmlComponent);
